import $ from "jquery";
import { API_URL } from "../../utils/constant";
import {
    toastr
} from "react-redux-toastr";
import axios from "axios";


var Actions = {
    saveLogo: file => {
        return new Promise((resolve, reject) => {
            var form = new FormData();
            form.append("file", file);
            const session = localStorage.getItem("session");
            var settings = {
                async: true,
                /*  */
                crossDomain: true,
                url: API_URL + "/customer/uploadImage",
                method: "POST",
                processData: false,
                contentType: false,
                mimeType: "multipart/form-data",
                headers: {
                    Authorization: "Bearer " + session
                },
                data: form,
                success: function (response) {
                    response = JSON.parse(response);
                    if (response.error) {
                        toastr.error("Error", response.userMessage);
                    } else {
                        resolve(response);
                    }
                },
                error: function (error) {

                    if (error.status === 401) {
                        localStorage.clear();
                    } else {
                        // message.error("Some error has occurred.");
                    }
                }
            };

            $.ajax(settings).done();
        });
    },
    uploadFile: file => {
        return new Promise((resolve, reject) => {
            var form = new FormData();
            form.append("file", file);
            const session = localStorage.getItem("session");
            var settings = {
                async: true,
                /*  */
                crossDomain: true,
                url: API_URL + "/customer/uploadExecutiveList",
                method: "POST",
                processData: false,
                contentType: false,
                mimeType: "multipart/form-data",
                headers: {
                    Authorization: "Bearer " + session
                },
                data: form,
                success: function (response) {
                    response = JSON.parse(response);
                    if (response.error) {
                        toastr.error("Error", response.userMessage);
                    } else {
                        resolve(response);
                    }
                },
                error: function (error) {
                    //     error
                    // });

                    if (error.status === 401) {
                        localStorage.clear();
                    } else {
                        // message.error("Some error has occurred.");
                    }
                }
            };

            $.ajax(settings).done();
        });
    },
    uploadSubdomain: (file,orgId) => {
        return new Promise((resolve, reject) => {
            var form = new FormData();
            form.append("file", file);
            const session = localStorage.getItem("session");
            var settings = {
                async: true,
                /*  */
                crossDomain: true,
                url: API_URL + "/uploadSubDomain?organisationId="+orgId,
                method: "POST",
                processData: false,
                contentType: false,
                mimeType: "multipart/form-data",
                headers: {
                    Authorization: "Bearer " + session
                },
                data: form,
                success: function (response) {
                    response = JSON.parse(response);
                    if (response.error) {
                        toastr.error("Error", response.userMessage);
                    } else {
                        resolve(response);
                    }
                },
                error: function (error) {
                    //     error
                    // });

                    if (error.status === 401) {
                        localStorage.clear();
                    } else {
                        // message.error("Some error has occurred.");
                    }
                }
            };

            $.ajax(settings).done();
        });
    },
    enableTwoFactor: (token,secret) => {
        return new Promise((resolve, reject) => {
            const session = localStorage.getItem("session");
            axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
            axios
                .post(`${API_URL}/enable2FA`, { token, secret })
                .then((response) => {
                    if (!response.data.error) {
                        // toastr.success("Success", response.data.userMessage);
                        resolve(response);
                    } else {
                        toastr.error("Error", response.data.userMessage);
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        localStorage.clear();
                    }
                });
        });
    },
}

export default Actions;